import PageHero from '../shared/PageHero.jsx';
import Reveal from '../shared/Reveal.jsx';
import EnquiryForm from '../sections/EnquiryForm.jsx';
import Seo from '../seo/Seo.jsx';
import { metaFor } from '../seo/routes.js';
import { contactLines, schoolHours } from '../constants/contact.js';
import { school } from '../constants/school.js';

export default function Contact() {
  return (
    <>
      <Seo {...metaFor('/contact')} path="/contact" />

      <PageHero
        eyebrow="Contact us"
        title="A person answers the phone. Between 8 and 5, every weekday."
      />

      <section className="bg-cream pb-20 pt-5">
        <div className="mx-auto grid max-w-[1240px] items-start gap-[34px] px-5 sm:px-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]">
          <Reveal className="flex flex-col gap-4">
            <div className="rounded-[26px] border-[3px] border-forest bg-white px-6 py-6 shadow-[0_9px_0_rgb(20_83_45_/_0.12)]">
              <h2 className="font-display text-[23px] font-extrabold text-forest">
                Visit us
              </h2>
              <address className="mt-2 text-base not-italic leading-[1.6] text-ink-soft">
                {school.address.split(', ').map((line) => (
                  <span key={line} className="block">
                    {line}
                  </span>
                ))}
                <span className="block">Nigeria</span>
              </address>
              <p className="mt-2.5 text-[15px] text-ink-soft/80">
                Open visits run every Tuesday at 10:00 — no booking needed, no staged open
                day.
              </p>
            </div>

            <div className="rounded-[26px] border-[3px] border-forest bg-white px-6 py-6 shadow-[0_9px_0_rgb(20_83_45_/_0.12)]">
              <h2 className="font-display text-[23px] font-extrabold text-forest">
                Talk to us
              </h2>
              <ul className="mt-2.5 flex flex-col gap-2.5 text-base text-ink-soft">
                {contactLines.map((line) => (
                  <li key={line.value}>
                    <a href={line.href} className="font-bold text-forest hover:text-coral">
                      {line.value}
                    </a>
                    {line.detail && ` · ${line.detail}`}
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-[26px] border-[3px] border-forest bg-sun px-6 py-6 shadow-[0_9px_0_rgb(20_83_45_/_0.16)]">
              <h2 className="font-display text-[23px] font-extrabold text-forest">
                School hours
              </h2>
              <dl className="mt-2.5 flex flex-col gap-[7px] text-[15.5px] text-[#3d3418]">
                {schoolHours.map((row) => (
                  <div key={row.label} className="flex justify-between gap-4">
                    <dt>{row.label}</dt>
                    <dd className="font-bold">{row.time}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>

          {/* The real enquiry form, the same one the homepage submits with — a
              second, decorative copy would be a form that goes nowhere. */}
          <Reveal>
            <EnquiryForm />
            <p className="mt-3 text-center text-[13.5px] text-ink-soft/80">
              Or just walk in on a Tuesday morning at 10:00.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
